<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <h3>
        ({{search.level}}级){{$route.meta.title}}
      </h3>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-row>
      <router-link :to="{ path: '/teke_tag/infinite_form/'+search.pid+'?level='+Number(search.level)}">
        <el-button type="primary">新建标签</el-button>
      </router-link>
      <br/><br/>
    </el-row>

    <layout-panel :show-header="false">
      <el-table ref="multipleTable"
                :data="table"
                stripe
                highlight-current-row
                style="width: 100%">
        <el-table-column prop="id"
                         label="标签类别id"></el-table-column>
        <el-table-column prop="tagname"
                         label="标签类别"></el-table-column>
        <el-table-column prop="price"
                         label="定价(元/份)"></el-table-column>
        <el-table-column prop="tagdesc"
                         label="标签描述"></el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         width="150">
          <template slot-scope="scope">
            <router-link :to="{ path: '/teke_tag/infinite_update/'+scope.row.id+'?level='+Number(search.level)}">
              <el-button type="text"
                         size="mini">修改
              </el-button>
            </router-link>
            <router-link
              :to="{ path: '/teke_tag/infinite_table?pid='+scope.row.id+'&level='+(Number(parseInt(scope.row.level)+1))}">
              <el-button type="text"
                         size="mini">标签管理
              </el-button>
            </router-link>
            <el-button type="text"
                       size="mini"
                       @click="deleteTag(scope.row.id)">删除
            </el-button>
            <router-link :to="'/teke_tag/infinite_upload_table?number='+ scope.row.id">
              <el-button type="text"
                         size="mini">上传列表
              </el-button>
            </router-link>

            <el-upload class="upload-demo"
                       ref="upload"
                       action=""
                       :auto-upload="false"
                       :on-change="query => onChangeFile(query,scope.row.id,1)"
                       accept=".xlsx,.xls"
                       :show-file-list="false">
              <el-button size="mini"
                         type="text">批量添加
              </el-button>
            </el-upload>

            <el-upload class="upload-demo"
                       ref="upload"
                       action=""
                       :auto-upload="false"
                       :on-change="query => onChangeFile(query,scope.row.id,2)"
                       accept=".xlsx,.xls"
                       :show-file-list="false">
              <el-button size="mini"
                         type="text">批量删除
              </el-button>
            </el-upload>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>

  </div>
</template>

<script>
import table from '@core/mixins/table'

export default {
  mixins: [table],
  data () {
    return {
      multipleSelection: [],
      // 表格数据
      table: [],
      // 分页参数
      pagination: {
        current_page: 1,
        per_page: 20,
        total: 0,
      },
      search: {
        pid: this.$route.query.tagid,
        level: this.$route.params.level,
      },
      // 搜索字段申明
      searchFieldType: {
        pid: Number,
        level: Number,
      },
    }
  },

  computed: Vuex.mapState({}),

  methods: {
    ...Vuex.mapActions(['getTekeInfiniteTagTable', 'deleteTekeTag', 'batchAddTeke', 'batchDeleteTeke']),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      return request.common('getTekeInfiniteTagTable', params)
    },
    deleteTag (id) {
      return request.common('deleteTekeTag', id).then((res) => {
        this.$message({
          showClose: true,
          message: '删除成功',
          type: 'success',
        })
        this.$refs.multipleTable.clearSelection()
        this.onSearch()
      })
    },
    onChangeFile (file, tagid, type) {
      let isLt2M = file.raw.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('大小不能超过2MB!')
        this.$refs.upload.clearFiles()
        return false
      }
      if (type === 1) {
        this.onBatchAddFile(file.raw, tagid)
      } else if (type === 2) {
        this.onBatchDeleteFile(file.raw, tagid)
      }
    },
    onBatchAddFile (file, tagid) {
      let formData = new FormData()
      formData.append('file', file)
      formData.append('tagid', tagid)
      return request.common('batchAddTeke', formData).then(({data}) => {
        this.$message({
          showClose: true,
          message: '上传成功',
          type: 'success',
        })
      })
    },
    onBatchDeleteFile (file, tagid) {
      let formData = new FormData()
      formData.append('file', file)
      formData.append('tagid', tagid)
      return request.common('batchDeleteTeke', formData).then(({data}) => {
        this.$message({
          showClose: true,
          message: '上传成功',
          type: 'success',
        })
      })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/views/teke-tag/pages/TekeInfiniteTagTable.vue